import { apiRequest } from '@/utils/api-request';

/**
 * Personal Access Token as returned by the listing endpoint.
 * Contract source: clj-pg-wrapper PATResponse
 * (src/schemas/personal_access_token.py). The plaintext token is NEVER
 * included in listings.
 */
export interface UserPat {
  id: string;
  name: string;
  expires_at: string;
  last_used_at: string | null;
  is_active: boolean;
  created_at: string;
}

/**
 * Shape returned once at creation. Contract source: clj-pg-wrapper
 * PATCreateResponse — includes the plaintext `token` (shown only once) but
 * NOT `last_used_at` / `is_active` (those only exist on the listing shape).
 */
export interface CreatedUserPat {
  id: string;
  name: string;
  token: string;
  expires_at: string;
  created_at: string;
}

export interface CreateUserPatProps {
  name: string;
  expiresInDays?: number;
}

export const createUserPat = async ({
  name,
  expiresInDays = 90,
}: CreateUserPatProps): Promise<CreatedUserPat> => {
  const response = await apiRequest<CreatedUserPat>({
    url: '/api-tokens',
    method: 'POST',
    target: 'platform',
    body: { name, expires_in_days: expiresInDays },
  });

  if (response?.detail) {
    throw new Error(
      response.detail || 'Failed to create personal access token',
    );
  }

  if (!response.data) {
    throw new Error('Failed to create personal access token');
  }

  return response.data;
};
